import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Loader2 } from 'lucide-react';
import { SALES_ENABLED } from '../../lib/featureFlags';

/**
 * Fullscreen blocking overlay shown while a Stripe checkout session
 * is being created. Sonner toasts disappear when window.location.href
 * redirects to Stripe, leaving the user with no visible feedback.
 * This overlay stays until the redirect actually happens.
 */
const CheckoutLoadingOverlay = ({ language = 'sv' }) => {
  if (!SALES_ENABLED) return null;

  const title =
    language === 'de' ? 'Sichere Zahlung wird vorbereitet'
    : language === 'en' ? 'Preparing secure payment'
    : 'Förbereder säker betalning';
  const subtitle =
    language === 'de' ? 'Du wirst gleich zu Stripe weitergeleitet…'
    : language === 'en' ? 'You will be redirected to Stripe shortly…'
    : 'Du skickas till Stripe om ett ögonblick…';

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm flex items-center justify-center px-4"
      data-testid="checkout-loading-overlay"
    >
      <Card className="max-w-md w-full">
        <CardContent className="py-10 text-center space-y-4">
          <Loader2 className="h-12 w-12 animate-spin mx-auto text-forest-600" />
          <div>
            <p className="text-lg font-semibold text-forest-800">{title}</p>
            <p className="text-sm text-muted-foreground mt-2">{subtitle}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutLoadingOverlay;
